import {BellOutlined, RightOutlined, SettingOutlined} from '@ant-design/icons';
import {NavLink} from "../../lib/Navigation";
import general, {redux} from "../../general";
import useActiveState from "../../lib/useActiveState";
import useActiveEffect from "../../lib/useActiveEffect";
import {useLocalStorageState, useLockFn, useMount, useScroll} from "ahooks";
import {useEffect, useState} from "react";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";
import {Link} from "react-router-dom";
import MobileDetect from "mobile-detect";
import URI from "urijs";
import { Badge } from 'antd-mobile';
import PubSub from 'pubsub-js';
import Manager from '../components/Manager';
import MyChats from './MyChats';
import CopyToClipboard from 'react-copy-to-clipboard';
import AuthAlert from '../components/AuthAlert';
import useInviteFriends from '../components/useInviteFriends';

export default props => {
  
  const [config] = useActiveState('config');
  const [user, setUser] = useActiveState('user');
  const [agent] = useActiveState('agent');
  const [app] = useActiveState('app');
  const [opacity, setOpacity] = useState();
  const [coinPopState, setCoinPopState] = useState(false);
  const [localPoint,setLocalPoint] = useLocalStorageState('local-point')
  const [rebate_notread_count,set_rebate_notread_count] = useState(0)
  const [isCheckAuth, setIsCheckAuth] = useState(false); //实名认证弹框状态
  const invitePath = useInviteFriends()

  const load = useLockFn(async () => {
    // Dialog.loading();
    await general.axios.post('/user/user/getMemberInfo')
      .finally(() => {
        // Dialog.close();
      })
      .then(response => {
        let {status, data} = response.data;
        if (!status.succeed) {
          if (status.error_code == 1016) {
            localStorage.removeItem('user_id');
            localStorage.removeItem('username');
            localStorage.removeItem('token');
            localStorage.removeItem('yx_account');
            localStorage.removeItem('yx_token');
            PubSub.publish('loginSubscribe',false)
          } else {
            Dialog.error(status.error_desc);
          }
        } else {
          localStorage.setItem('yx_account',data.member_info.yx_account)
          localStorage.setItem('yx_token',data.member_info.yx_token)
          setUser({isLogin: true, ...data.member_info});
        }
      })
  });
  useMount(() => {
    if (general.isLogin()) {
      load();
    }
  });
  useActiveEffect(() => {
    if (general.isLogin()) {
      if (!user.isLogin) {
        load();
      }
    } else {
      setUser({isLogin: false});
    }
  });

  const scroll = useScroll();
  useEffect(() => {
    if (props.active && general.isLogin()) {
      // if (scroll.top < -80) {
        load();
      // }
    }
  }, [props.active]);

  useEffect(() => {
    let opacity;
    if (props.active) {
      if (scroll.top) {
        console.log()
        // opacity = Math.abs(scroll.top) / 200;
        // if (opacity > 1) {
        //   opacity = 1;
        // }
        opacity = 1;
      } else {
        opacity = 0;
      }
    }
    setOpacity(opacity);
  }, [scroll, props.active]);

  const [messageUnreadNum, setMessageUnreadNum] = useState(0);
  const messUnreadCount = useLockFn(async (parms = {}) => {
    // Dialog.loading();
    general.axios.post('getUnreadNumberMess')
      .finally(() => {
        // Dialog.close();
      })
      .then(res => {
        let {status, data} = res.data;
        if (!status.succeed) {
          return;
        }
        redux.dispatch({
          type:'updateMessageUnread',
          data:{
            messageUnreadNumber:data.message_unread_num == 0 ? -1 : data.message_unread_num
          }
        })
        setMessageUnreadNum(data.message_unread_num);
        set_rebate_notread_count(data.rebate_notread_count)
      })
  });

  useEffect(()=>{
    if (props.active && general.isLogin()) {
      messUnreadCount();
    }

  }, [props.active]);

  const [dependentData,setDependentData] = useState({})
  const getUserDependentData = ()=>{
    general.axios.post("/user/userDependent/getUserDependentData")
    .then(res=>{
      let {status, data} = res.data;
      if (status.succeed == 1){
        setDependentData(data)
      }
    })
  }
  useEffect(()=>{
    if (props.active){
      getUserDependentData()
    }
  },[props.active])

  // style={{opacity: opacity !== undefined ? opacity : 1}}
  // 

  return <>
    {Object.keys(dependentData).length > 0 ? <div className="user-index" style={{backgroundImage:'url(resources/250410/user.bg.png)',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat'}}>
    <div className={"user-halo width "}>
      <div className="container">
        <div></div>
        <div className="operate">
          <NavLink to="/message" onClick={()=>Manager.push({event_id:'A-5-2'})} className="item">消息{messageUnreadNum > 0 ? <i className='tip'></i> : null }</NavLink>
          <Link to="/set" onClick={()=>Manager.push({event_id:'A-5-3'})} className="item">设置</Link>
        </div>
      </div>
    </div>
    <div className="user-head">
      <div className="container">
        <NavLink onClick={()=>Manager.push({event_id:'A-5-1'})} to="/user" className="user">
          <div className="icon">
            <Image className="avatar" src={user.avatar_status === '-1'? '/resources/user/avatar.png' : (user.icon_link || '/resources/user/avatar.png')} alt=""/>
          </div>
          <div className="info">
            {user.isLogin && <NavLink to='/user/nickname' style={{display:'inline-block'}}>
              <span style={{fontSize:'18px',fontWeight:'500',color:'#282828',paddingRight:'5px'}}>{user.nick_name}</span>
              <img src="resources/250410/edit.png" alt="" height={16}/>
            </NavLink>}
            {user.isLogin ? <>
              <div className="name" style={{fontSize:'0.22rem',color:'#666',position:'relative',top:'0px'}}>账号：{user.member_name} 
                <CopyToClipboard text={user.member_name} onCopy={() => Dialog.info('复制成功')}>
                  <img 
                    src="resources/250410/copya.png" 
                    height={20} 
                    alt="" 
                    style={{padding:'5px', cursor: 'pointer',verticalAlign:'middle'}} 
                    onClick={e => {
                      e.stopPropagation();
                      e.preventDefault();
                    }}
                  />
                </CopyToClipboard>
              </div>            
            </> : <div className="empty">登录/注册</div>}
            {user.isLogin && <div  className='content'>
              <NavLink to='/save/newvip' onClick={()=>{
                Manager.push({event_id:"A-5-7"})
              }}>
                <>
                {(() => {
                  if(user?.vip_level == 1) {
                    return <div className='rank-level'><img src="/resources/modifyprice/monthly_card.png" /></div>
                  } else if(user?.vip_level == 2) {
                    return <div className='rank-level'><img src="/resources/modifyprice/season_card.png" /></div>
                  } else if(user?.vip_level == 3) {
                    return <div className='rank-level'><img src="/resources/modifyprice/year_card.png" /></div>
                  } else {
                    return <div className='rank-level'><img src="/resources/modifyprice/member.png" /></div>
                  }
                })()}
                </>
              </NavLink>
              <NavLink to='/growthlevel' onClick={()=>{
                Manager.push({event_id:'A-5-23'})
                setLocalPoint('1')
              }} className='desc'>
              <img src={dependentData?.honor?.icon} alt="" width={24}/>
                <span className='text'>{dependentData?.honor?.title}</span>
                <img src="resources/modifyprice/right.png" alt="" style={{height:'7px',marginLeft:'1px'}}/>
                {!localPoint && <div className="point"></div>}
              </NavLink>
            </div>}
            {/* {
              mobileDetect.os() == 'iOS' ?
                config.vipsignLifeTimeDesc ? 
                <div className='usefultime'>{config.vipsignLifeTimeDesc}</div> 
                : 
                user.vipsignLifeTimeDesc ? <div className='usefultime'>{user.vipsignLifeTimeDesc}</div> : null
                
              : null
            } */}
          </div>          
        </NavLink>
       
      </div>
    </div>
    <div className="user-body">      

      <div className="economy">
        <NavLink onClick={()=>{
            if(user.isCheckAuth && !user.isRealNameAuth) {
              setIsCheckAuth(true);
              return;
            }
            Manager.push({event_id:'A-5-4'})
        }}
          to={(() => {
            if(user.isCheckAuth && !user.isRealNameAuth) {
              return;
            }
            let url = URI("https://sys.99maiyou.com/home/MixPay/ptb")
                .addQuery('username', localStorage.getItem('username'))
                .addQuery('token', localStorage.getItem('token'))
                .addQuery('location_url', window.location.origin)
                .addQuery('agent', agent)
                .addQuery('from', 'react')
                .toString();
            return url;
          })()}
          user={true} iframe={{title:'平台币充值', sinfo:'nisptb'}} className="item" >
          <div className='info'>
            <div className='ec-link-text'>
              <div className="text-info">钱包<span style={{color:'#666',fontSize:'0.22rem'}}>(平台币)</span></div>
            </div>
            <div className='value'><span>{user.platform_coins ? user.platform_coins.replace('.00', '') : 0}</span>个</div>
          </div>
        </NavLink>
        <div className="item" onClick={() => {setCoinPopState(true),Manager.push({event_id:'A-5-5'})}}>
          <div className="info">
            <div className="ec-link-text">
              <div className='text-info'>金币</div>
            </div>
            <div className="value"><span>{user.gold_coins ? user.gold_coins.replace('.00', '') : 0}</span>个</div>
          </div>
        </div>
        <NavLink onClick={()=>Manager.push({event_id:'A-5-6'})} to="/user/voucher" className="item">
          <div className="info">
            <div className="ec-link-text">
              <div className='text-info'>代金券</div>
            </div>
            <div className="value"><span>{user.available_voucher ? user.available_voucher.replace('.00', '') : 0}</span>张</div>
          </div>
        </NavLink>
      </div>


      {/** 会员and省钱卡 **/}
      {
        !config.isHideVipACard ? 
        <div className='general-card' style={{backgroundImage:'url(/resources/250410/card.png)',backgroundSize:'100% 100%',borderRadius:'9px'}}>
        <div className='items'>
          <NavLink onClick={()=>Manager.push({event_id:'A-5-8'})} user={false} to="/save/newcard" className="item">
            <img className='icon' src={dependentData?.card?.icon} alt="" />
            <div className="content" style={{display:'flex',justifyContent:'flex-start',alignItems:'center'}}>
              <div className='title'>
                {dependentData?.card?.title}
              </div>
              <div className='desc'>
                {dependentData?.card?.desc}
              </div>
              <div style={{
                backgroundImage:'url("resources/250410/card-btn-bg.png")',
                backgroundSize:'100% 100%',
                padding:'3px 10px',
                color:'#571A00',
                fontSize:'11px',
                fontWeight:'500',
                marginRight:'15px'
                }}>
                {dependentData?.card?.button}
              </div>
            </div>
            {dependentData?.card?.cardReceiveText?.length > 0 && <div className='tips'>{dependentData?.card?.cardReceiveText}</div>}
          </NavLink>
          <div>
          </div>
          {/* <div className='items-line'>
            <img src="resources/user/index1/line.png" alt="" />
          </div>
          <NavLink onClick={()=>Manager.push({event_id:'A-5-7'})} user={false} to="/save/newvip" className="item">
            <img className='icon' src="resources/user/index1/member.png" alt="" />
            <div className="content">
              <img className='title' src='resources/user/index1/member-title.png'/>
              <div className='desc'>
                {config?.vip_desc}
              </div>
            </div>
          </NavLink> */}
        </div>
        </div> : null
      }
      
      <NavLink onClick={()=>Manager.push({event_id:'A-5-10'})} user={false} to="/hangup" className="hangup">
        <div className="item">
          <div className="container">
            <div className="content">
              <div className="icon">
              {dependentData?.cloud_hangup?.title}<span style={{color:'#FC263F',fontSize:'11px',paddingLeft:'10px'}}>{dependentData?.cloud_hangup?.tips}</span>
              </div>
              <div className="content">{dependentData?.cloud_hangup?.bottom_desc}</div>
            </div>
            {dependentData?.cloud_hangup?.list?.length > 0 && <div className="game" style={{display:'flex',alignItems:'center',paddingRight:'4px'}}>
              <div className='title'>{dependentData?.cloud_hangup?.desc}</div>
              <div className="icons" style={{display:'flex',alignItems:'center',paddingLeft:'4px'}}>
                {dependentData?.cloud_hangup?.list?.map(item=>{
                  return (
                    <div style={{paddingRight:'2px',display:'flex',alignItems:'center'}}>
                      <img height={15} src={item} alt="" />
                    </div>
                  )
                })}
              </div>
            </div>}
          </div>
          <img className="more" src="/resources/welfare/left-back.png" alt="" />
        </div>
      </NavLink>

      <div className="chats" style={{backgroundColor:'white',padding:'15px',borderRadius:'9px'}}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
          <span style={{fontSize:'17px',fontWeight:'500',color:'#282828'}}>我的游戏</span>
          <NavLink to='/user/game' onClick={()=>{
            Manager.push({event_id:'A-5-14'})
          }} style={{fontSize:'11px',color:'#999',display:'flex',alignItems:'center'}}>更多&nbsp;<img src="/resources/welfare/left-back.png" width={10} alt="" /> </NavLink>
        </div>
        {user.isLogin && dependentData.my_game_list?.length > 0 ? <MyChats active={props.active} items={dependentData?.my_game_list}></MyChats> : 
        <NavLink>
          <div style={{display:'flex',alignItems:'center',justifyContent:'center',padding:'20px 0 15px'}}>
            <img src="resources/250410/user.png" height={20} alt="" />
            <div style={{color:'#282828',fontSize:'14px',paddingLeft:'5px'}}>{dependentData.my_game_list?.length == 0 && user.isLogin ? '您还没有玩过任何游戏~' : '登录查看我的游戏'}</div>
          </div>
        </NavLink>
        }
      </div>
      
      <div style={{
        backgroundColor:'white',
        borderRadius:'9px'
      }}>
      <div className="general-title">
        <div className="title" style={{padding:'15px 0 0 15px'}}>玩家服务</div>
      </div>
      <div className="general-func">
        <div className="items clearfix">
          <Link to={'/service'} onClick={()=>Manager.push({event_id:'A-5-19'})} className="item">
            <div className="icon"><img src="/resources/250410/kefu.png" alt=""/></div>
            <div className="text">在线客服</div>
          </Link>
          <NavLink onClick={()=>{
            Manager.push({event_id:'A-5-12'})
            
          }} to="/user/gift" className="item">
            <div className="icon"><img src="/resources/250410/libao.png" alt=""/></div>
            <div className="text">我的礼包</div>
          </NavLink>
          <NavLink onClick={()=>{
            Manager.push({event_id:'A-5-13'})
            
          }} to="/user/bill" className="item">
            <div className="icon"><img src="/resources/250410/zhangdan.png" alt=""/></div>
            <div className="text">我的账单</div>
          </NavLink>
          <NavLink onClick={()=>{
            Manager.push({event_id:'A-5-15'})
            
          }} to="/user/record" className="item">
            <div className="icon"><img src="/resources/250410/zuji.png" alt=""/></div>
            <div className="text">我的足迹</div>
          </NavLink>
          <NavLink onClick={()=>{
            Manager.push({event_id:'A-5-16'})
            
          }} to="/rebate" className="item">
            <div className="icon" style={{position:'relative'}}>
            <img src="/resources/250410/fanli.png" alt=""/>
            {rebate_notread_count > 0 && <div style={{position:'absolute',top:'0',right:'-4px',width:'7px',height:'7px',background:'#f00',borderRadius:'3.5px'}}></div>}
            </div>
            <div className="text">我的返利</div>
          </NavLink>
          <NavLink onClick={()=>{
            Manager.push({event_id:'A-5-17'})
            
          }} to="/around" className="item">
            <div className="icon"><img src="/resources/250410/zhuanyou.png" alt=""/></div>
            <div className="text">充值转游</div>
          </NavLink>
          {app.is_overseas ? 
            <NavLink user={false} onClick={()=>{
          }} to="/overseas-trade" className="item">
            <div className="icon"><img src="/resources/250410/jiaoyi.png" alt=""/></div>
            <div className="text">账号交易</div>
          </NavLink> : 
          <NavLink user={true} onClick={()=>{
            Manager.push({event_id:'A-5-18'})
          }} to={invitePath} className="item">
            <div className="icon"><img src="/resources/250410/yaoqing.png" alt=""/></div>
            <div className="text">邀请好友</div>
          </NavLink>}
          {/* <NavLink to="/recovery" className="item">
            <div className="icon"><img src="/resources/user/anomaly-recovery.png" alt=""/></div>
            <div className="text">小号回收</div>
          </NavLink> */}
        </div>
      </div>
      </div>

      {
        config.monthcard == 2 ? 
        <NavLink to="/save/newcard" className="card">
          <img src="/resources/user/card2.png?version=20210817" alt=""/>
        </NavLink>
        : null
      }
      
      {/* <div className="more-title">
        <div className="title">更多服务</div>
      </div>
      <div className="more-func">
        <div className="items clearfix">
          <NavLink to="/feedback" onClick={()=>Manager.push({event_id:'A-5-20'})} className="item">
            <div className="icon"><img src="/resources/user/anomaly-feedback1.png" alt=""/></div>
            <div className="text">投诉反馈</div>
          </NavLink>
          <div className="item" onClick={() => {Dialog.info('暂无QQ群'),Manager.push({event_id:'A-5-21'})}}>
            <div className="icon"><img src="/resources/user/anomaly-group1.png" alt=""/></div>
            <div className="text">加入QQ群</div>
          </div>
          <NavLink to="/user" onClick={()=>Manager.push({event_id:'A-5-22'})} className="item">
            <div className="icon"><img src="/resources/user/anomaly-save1.png" alt=""/></div>
            <div className="text">账号安全</div>
          </NavLink>
        </div>
      </div> */}
    </div>

    {/** 金币弹框 **/}
    {coinPopState ?
    <div className='user-coin-pop-index'>
      <div className='coin-pop-site'>
        <div className='content'>
          <div className='head'>
            <NavLink to="/user/bill?type=2" onClick={() => setCoinPopState(false)}>金币明细{'>'}</NavLink>
          </div>
          <div className='title'>
            <img src="/resources/user/coin-pop-img.png"/>
            <p>
              金币的使用和获取
            </p>
          </div>
          <div className='text'>
            <div className='desc'>
              <div className='name'>
                金币使用说明
              </div>
              <div className='info'>
                {/* 金币等同于平台币，可用于游戏内支付时抵扣，10金币等于1人民币，部分特殊BT游戏不支持金币支付。 */}
                金币作用等同于平台币，可用于游戏内支付抵扣，10金币相当于1元。折扣/H5和部分BT游戏不支持金币支付，具体以游戏支付页面显示为准
              </div>
            </div>
            <div className='desc'>
              <div className='name'>
                金币获取方式
              </div>
              <div className='info'>
                每日签到/福利中心任务/邀请好友/平台活动等...
              </div>
            </div>
          </div>
          <div className='operate' onClick={()=>setCoinPopState(false)}>
            我知道了
          </div>
        </div>

        <div className='close' style={{backgroundImage:'url(/resources/party/close.png)'}} onClick={()=>setCoinPopState(false)}>
        </div>
      </div>
    </div>
    : null}
    <AuthAlert isCheckAuth={isCheckAuth} onClose={() => setIsCheckAuth(false)} handleAuthSuccess={info=>{
      setUser({...user,...info})
    }}></AuthAlert>
  </div> : null}
  </>;
};